/* ===== LA PLANQUE — home.js (thème Shopify, hero fixe sans animation) ===== */
(function () {
  if (!document.querySelector(".hero")) return;
  gsap.registerPlugin(ScrollTrigger);

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Smooth scroll ---------- */
  const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
  lenis.on("scroll", ScrollTrigger.update);
  gsap.ticker.add((time) => lenis.raf(time * 1000));
  gsap.ticker.lagSmoothing(0);

  /* ---------- Préloader : ouverture du dossier (courte) ---------- */
  const preloader = document.getElementById("preloader");
  const loadCount = document.getElementById("loadCount");
  const dossierFill = document.getElementById("dossierFill");
  const tampon = document.getElementById("tampon");

  const load = { v: 0 };
  gsap.to(load, {
    v: 100, duration: reduceMotion ? 0.01 : 1.0, ease: "power2.inOut",
    onUpdate: () => {
      loadCount.textContent = Math.round(load.v);
      dossierFill.style.transform = `scaleX(${load.v / 100})`;
    },
    onComplete: () => {
      tampon.classList.add("hit");
      setTimeout(() => {
        preloader.classList.add("done");
        gsap.fromTo(".hero-title .line-inner",
          { yPercent: 110 },
          { yPercent: 0, duration: 1.2, stagger: 0.13, ease: "power4.out", delay: 0.35 });
      }, reduceMotion ? 0 : 750);
    },
  });

  document.querySelectorAll(".hero-title .line").forEach((line) => {
    const inner = document.createElement("span");
    inner.className = "line-inner";
    inner.innerHTML = line.innerHTML;
    line.innerHTML = "";
    line.appendChild(inner);
  });
  gsap.set(".hero-title .line-inner", { yPercent: 110 });

  /* ---------- Univers : parallaxe + entrées ---------- */
  document.querySelectorAll(".univers-media img").forEach((img) => {
    gsap.fromTo(img, { yPercent: -6 }, {
      yPercent: 6, ease: "none",
      scrollTrigger: { trigger: img.closest(".univers"), start: "top bottom", end: "bottom top", scrub: true },
    });
  });
  document.querySelectorAll(".univers-copy").forEach((copy) => {
    gsap.from(copy.children, {
      opacity: 0, y: 34, duration: 0.8, stagger: 0.1, ease: "power3.out",
      scrollTrigger: { trigger: copy, start: "top 78%", once: true },
    });
  });

  /* ---------- Horloge réelle ---------- */
  const horlogeLive = document.getElementById("horlogeLive");
  if (horlogeLive) setInterval(() => {
    horlogeLive.textContent = new Date().toLocaleTimeString("fr-FR");
  }, 1000);

  /* ---------- Confiance ---------- */
  gsap.to(".confiance-card", {
    opacity: 1, y: 0, duration: 0.9, stagger: 0.15, ease: "power3.out",
    scrollTrigger: { trigger: ".confiance-grid", start: "top 80%", once: true },
  });

  /* ---------- Jeu ---------- */
  const scene = document.getElementById("jeuScene");
  if (!scene) return;
  const timerEl = document.getElementById("jeuTimer");
  const foundEl = document.getElementById("jeuFound");
  const winEl = document.getElementById("jeuWin");
  let timeLeft, timerId, found;

  document.getElementById("jeuStart").addEventListener("click", () => {
    found = 0; timeLeft = 480;
    foundEl.textContent = "0";
    winEl.hidden = true;
    scene.classList.add("active");
    scene.querySelectorAll(".jeu-spot").forEach((s) => s.classList.remove("found"));
    clearInterval(timerId);
    timerId = setInterval(() => {
      timeLeft--;
      timerEl.textContent = `${Math.floor(timeLeft / 60)}:${String(timeLeft % 60).padStart(2, "0")}`;
      if (timeLeft <= 0) { clearInterval(timerId); scene.classList.remove("active"); timerEl.textContent = "0:00"; }
    }, 1000);
  });

  scene.querySelectorAll(".jeu-spot").forEach((spot) => {
    spot.addEventListener("click", () => {
      if (spot.classList.contains("found")) return;
      spot.classList.add("found");
      foundEl.textContent = ++found;
      if (found === 4) { clearInterval(timerId); winEl.hidden = false; }
    });
  });
})();
